<template>
	<div v-if="isWarning" class="session-countdown"
		:class="{ 'is-urgent': isUrgent }" role="status">
		<b-icon icon="clock-outline" size="is-small" class="mr-1" />
		Sitzung läuft in {{ remainingLabel }} ab
	</div>
</template>

<script>

import Parse from "parse/dist/parse.min.js";
import {
	fetchSessionExpiry, formatRemaining, nextTickDelay, WARN_BEFORE_MS
} from "@/lib/sessionExpiry";

export default {
	name: "SessionCountdown",
	data() {
		return {
			expiresAt: undefined,
			now: Date.now(),
			timerId: undefined,
		};
	},
	computed: {
		currentUser() {
			return this.$store.state.currentUser;
		},
		remainingMs() {
			if (!this.expiresAt) return undefined;
			return this.expiresAt.getTime() - this.now;
		},
		isWarning() {
			return this.remainingMs !== undefined
				&& this.remainingMs <= WARN_BEFORE_MS;
		},
		isUrgent() {
			return this.isWarning && this.remainingMs <= 60 * 1000;
		},
		remainingLabel() {
			return formatRemaining(this.remainingMs);
		},
	},
	watch: {
		currentUser() {
			this.refresh();
		},
	},
	mounted() {
		this.refresh();
		document.addEventListener("visibilitychange", this.tick);
	},
	beforeDestroy() {
		document.removeEventListener("visibilitychange", this.tick);
		this.stop();
	},
	methods: {
		async refresh() {
			this.stop();
			this.expiresAt = await fetchSessionExpiry();
			this.tick();
		},
		stop() {
			if (this.timerId === undefined) return;
			clearTimeout(this.timerId);
			this.timerId = undefined;
		},
		tick() {
			this.stop();
			if (!this.expiresAt) return;
			this.now = Date.now();
			if (this.remainingMs <= 0) return this.expire();
			this.timerId = setTimeout(this.tick, nextTickDelay(this.remainingMs));
		},
		async expire() {
			this.expiresAt = undefined;
			// The token is dead either way; a failed logOut must not keep
			// the user on the page.
			await Parse.User.logOut().catch(() => undefined);
			await this.$router.push("/login").catch(() => undefined);
			location.reload();
		},
	},
};
</script>

<style scoped>
.session-countdown {
	position: fixed;
	top: 0.4rem;
	left: 50%;
	transform: translateX(-50%);
	z-index: 40;
	display: flex;
	align-items: center;
	padding: 0.25rem 0.75rem;
	border-radius: 9999px;
	background-color: #ffdd57;
	color: rgba(0, 0, 0, 0.7);
	font-weight: 600;
	white-space: nowrap;
}

.session-countdown.is-urgent {
	background-color: #f14668;
	color: white;
}
</style>
